import { useMemo } from 'react';
export var useUserAgent = function useUserAgent() {
  var isIOSSafari = useMemo(function () {
    var agent = navigator.userAgent.toLowerCase();
    return agent.includes('iphone') && agent.includes('safari');
  }, []);
  return {
    isIOSSafari: isIOSSafari
  };
};